import { render } from "./OapTableOfContents.vue?vue&type=template&id=0cf09b7d"
import script from "./OapTableOfContents.vue?vue&type=script&lang=js"
export * from "./OapTableOfContents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__